import { NgModule } from '@angular/core';
// TODO:Spartacus - // TODO:Spartacus - Variable translations has been removed and is no longer part of the public API.
import { translationChunksConfig, translationsDe, translationsEn } from '@spartacus/assets';
import { defaultB2BCheckoutConfig } from '@spartacus/checkout/b2b/root';
import { FeaturesConfig, I18nConfig, OccConfig, provideConfig, SiteContextConfig } from '@spartacus/core';
import { defaultB2bOccConfig } from '@spartacus/setup';
import { defaultCmsContentProviders, layoutConfig, mediaConfig } from '@spartacus/storefront';
import { environment } from '../../environments/environment';
import { translationOverwrites } from '../custom/translation-overwrites';

@NgModule({
  declarations: [],
  imports: [
  ],
  providers: [provideConfig(layoutConfig), provideConfig(mediaConfig), ...defaultCmsContentProviders, provideConfig({
    backend: {
      occ: {
        ...environment.occ,
      }
    },
  } as OccConfig), provideConfig({
    context: {
      currency: ['EUR'],
      language: ['de', 'en'],
      urlParameters: ['language'],
      baseSite: ['efa-spa'],
    },
  } as SiteContextConfig), provideConfig({
    i18n: {
      resources: {
          en: translationsEn,
          de: translationsDe,
      },
      chunks: translationChunksConfig,
      fallbackLang: 'en'
    },
  } as I18nConfig), provideConfig({
    i18n: {
      resources: translationOverwrites
    },
  } as I18nConfig), provideConfig({
    features: {
      level: '4.2'
    }
  } as FeaturesConfig), provideConfig(defaultB2bOccConfig), provideConfig(defaultB2BCheckoutConfig)]
})
export class SpartacusConfigurationModule {
}
